//This is a wrapper for the Generic Product Card
import { connect } from 'react-redux';
import ProductCard from '../../generic/ProductCardSimple';
// import {customerNevers} from '../const';
import { togglePdpModal } from '../../generic/global_state/action_creators';

const CProductCard = ({ data, togglePdpModal }) => {
  return (
    <a
      className="cproduct-card"
      href={`/products/${data.slug}`}
      onClick={(e) => e.preventDefault()}
    >
      <ProductCard
        id={data.id}
        name={data.name}
        brand={data.brand_name}
        img={data.card_image_url}
        isNew={data.is_new}
        onClick={() => togglePdpModal(data)}
        tags={data.short_dietary_tags ? data.short_dietary_tags : null}
      />
    </a>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    togglePdpModal: (product) => dispatch(togglePdpModal(product)),
  };
};

export default connect(null, mapDispatchToProps)(CProductCard);
